import { throwError as observableThrowError, BehaviorSubject, Observable } from 'rxjs';
import { catchError, filter, take, switchMap, finalize } from 'rxjs/operators';
import { Injectable, Injector } from '@angular/core';

import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpErrorResponse } from '@angular/common/http';
import { ConfigService } from './services';
import { Config, Refresh } from './models';
import { Router } from '@angular/router';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  config: Config;
  isRefreshingToken = false;
  tokenSubject: BehaviorSubject<string> = new BehaviorSubject<string>(null);
  configService: ConfigService;
  constructor(private injector: Injector, private router: Router) {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    this.configService = this.injector.get(ConfigService);
    this.config = this.configService.getConfig();

    return next.handle(request).pipe(
      catchError(err => {
        if (err instanceof HttpErrorResponse) {
          if (err.status === 401) {
            if (err.error == "unauthorized")
            {  
              return this.nagivateToUnauthorized();
            }
            return this.login();
          }
        }
        return observableThrowError(err);
      })
    );
  }

  private login() {
    // window.location.href = this.config.appRoot + 'support/login?redirectUrl=' + encodeURIComponent(window.location.href);
    return observableThrowError('');
  }

  private nagivateToUnauthorized() {
    this.router.navigate(['unauthorized']);
    return observableThrowError('');
  }
}
